import LazyLoad from "jquery-lazy";
$(function() {
    $('.lazy').Lazy({
        scrollDirection: 'vertical',
        effect: 'show',
        visibleOnly: true,
    });
});